import { createSlice } from '@reduxjs/toolkit'

export const hasDiagramChangeSlice = createSlice({
    name: 'hasDiagramChange',
    initialState: {
        hasChanges: false,
    },
    reducers: {
        setHasDiagramChange: (state, action) => {
            state.hasChanges = action.payload;
        },
    },
})

export const { setHasDiagramChange } = hasDiagramChangeSlice.actions;

export const getHasDiagramChange = (state) => state.hasDiagramChange.hasChanges;

export default hasDiagramChangeSlice.reducer